const rnYaz = (n) => `R${String(n).padStart(3, "0")}`;
/** SN gövdesi: yalnız rakamdan oluşan, 5 ve daha çok haneli parça. Ardından SN eki "-1" ya da "-01" gelebilir. */
const SN = String.raw `(?:^|[-_ ])\d{5,}`;
const SN_EKI = "[-_ ]0?1";
/** Adın sonundaki 8 ve daha çok haneli tek damga ("…-47-1606251405") okunmaz. */
const DAMGA = String.raw `(?:[-_ ]\d{8,})?$`;
/** "…-152092-1-(135)-135", "…-152112-(144)-144": parantezdeki ile sondaki aynı olmalıdır. */
const SON_PARANTEZLI = new RegExp(String.raw `${SN}(?:${SN_EKI})?[-_ ]\((\d{1,3})\)[-_ ](\d{1,3})${DAMGA}`);
/** "…-1310511-1-25", "…-1306732-01-48-1606251405". */
const SON_DUZ = new RegExp(String.raw `${SN}${SN_EKI}[-_ ](\d{1,3})${DAMGA}`);
/** Ad SN gövdesiyle (ve ekiyle) bitiyor: sonda riser numarası yok. */
const SON_YOK = new RegExp(`${SN}(?:${SN_EKI})?$`);
/** Sondaki SN gövdesinin önü bir SN + 1-3 haneli parçalarla bitiyor. Yalnız SN eki ise ("…-1306672-1-1283910-1") sorun yoktur. */
const ONDE_SAYI = new RegExp(String.raw `${SN}(?:[-_ ]\(?\d{1,3}\)?)+$`);
const ONDE_EK = new RegExp(`${SN}${SN_EKI}$`);
/** Sondaki kopya ekleri, art arda olabilir: tarayıcının " (1)"i (tek hane), Windows'un " - Copy" ve " - Kopya"sı. */
const KOPYA_EKI = /(?:\s*\(\d\)|\s+-\s+(?:COPY|KOPYA))+$/;
/**
 * Dosya adından raporun türü ve riser numarası (D-065): SURVREP PDF'i ile girdi excel'i aynı satırda bu kuralla eşlenir.
 * Sunucu (toplu disposition / rework yükleme) ve tarayıcı aynı kuralı kullanır. `sokumRnBul` bu adları okumaz: SURVREP adında
 * riser numarası etiketsizdir, adın başında ve/ya da sonunda durur.
 *
 * Tür: adında REWORK sözcüğü geçen rework ("reworked", "fireworks" o sözcük değildir); DISPOSITION, CONVENTIONAL ya da INITIAL
 * INSPECTION geçen disposition. İkisi birden geçiyorsa ya da hiçbiri geçmiyorsa null.
 *
 * Riser yalnız ad aşağıdaki kalıplardan birine TAM uyuyorsa okunur; uymayan her ad null verir (toplu yükleme o satırda riseri
 * sorar). Sormak her zaman güvenlidir, yanlış riser değildir: kural bilerek dardır.
 * 1. Etiketli: ad "R" + en çok 3 haneyle başlar ("R002-disposition-input-EN.xlsx", "R047 conventional inspection.pdf";
 *    "R0470" ve "R1234" okunmaz). Adın kalanında başka bir riser numarası olabilecek parça varsa null: tek başına duran 1-3
 *    haneli sayı ya da R, RN, RISER, NO + 1-3 hane ("R047-48 …", "R047,048 …", "R047 … R048", "R1-R047 …", "R047 … EN-2").
 *    Harfe yapışık sayı ("v2", "75ft") ve dört ve daha çok haneli sayı ("2026") böyle parça değildir; aynı numara yinelenebilir.
 * 2. Baştaki: ad 1-3 hane + SURVREP ile başlar ("002-SURVREP-…").
 * 3. Sondaki: önce sondaki kopya ekleri (" (1)", " (1) (2)", " - Copy", " - Kopya"; parantezdeki tek hanedir) atılır; sonra ad
 *    şunlardan biriyle bitmelidir (sonda 8 ve daha çok haneli tek damga olabilir, "…-47-1606251405"):
 *    - SN gövdesi (5 ve daha çok hane) + SN eki "-1" ya da "-01" + 1-3 haneli numara ("…-1310511-1-25", "…-1306732-01-48");
 *    - SN gövdesi + (varsa SN eki) + parantezde numara + aynı numara ("…-152092-1-(135)-135", "…-152112-(144)-144").
 *    Sondan başka şey çıkan ad ("…-1-47_2", "…-1-47-2", "…-1-47-final", "…-1-47 (100)", "…-1-0047") bu kalıplara uymaz.
 *    Baştaki numarası olmayan adda "…-<SN>-1-1" de okunmaz: sondaki 1, riser 1 de olabilir, riseri yazılmamış adın kopya eki de.
 * 4. Birleştirme (adında SURVREP geçenlerde): SURVREP'ten önce ya hiç rakam yoktur, ya yalnız baştaki numara, ya da yalnız
 *    etiket durur; önünde başka biçimde rakam olan ad ("0047-SURVREP…", "RN047-SURVREP…", "Riser 47 SURVREP…",
 *    "R047-048-SURVREP…") null verir. Baştaki (ya da etiketli) ile sondaki ikisi de okunduysa aynı olmalıdır, değilse null.
 *    Yalnız sondaki okunduysa o. Baştaki numara tek başına yalnız ad SN gövdesiyle (ve ekiyle) bitiyorsa geçerlidir
 *    ("047-SURVREP-…-1306733-1"); o SN'in hemen önünde bir SN + 1-3 haneli parça duruyorsa ("…-1306733-1-048-120526") son
 *    tanınmamış sayılır. Sonu tanınmayan adda baştaki numaraya güvenilmez; etiketli numara ise ancak adın kalanı 1. kuraldaki
 *    gibi başka numara taşımıyorsa geçerlidir ("R047 survrep conventional.pdf").
 * 5. 0 riser değildir.
 * Ad tek başına güven değildir: excel'in RN'i ve rapor kapağı ayrıca denetlenir.
 */
export function raporDosyaBul(ad) {
    const t = (ad ?? "").toUpperCase().replace(/\.(PDF|XLSX)$/, "");
    const rework = /(?:^|[^A-Z])REWORK(?:[^A-Z]|$)/.test(t);
    const disposition = /DISPOSITION|CONVENTIONAL|INITIAL[-_ ]?INSPECTION/.test(t);
    const tur = rework === disposition ? null : rework ? "rework" : "disposition";
    return { tur, rn: rnBul(t) };
}
/**
 * Adı başka bir belge ailesini söyleyen dosya (söküm kaydı, MRB): Disposition ve Rework pencereleri bunu kendi raporu saymaz.
 * Yalnız kesin olan sözcükler aranır; türü okunamayan başka adlar ("R047.pdf") bu pencerelerin sayılmaya devam eder.
 */
export function raporBaskaAile(ad) {
    return /DISASSEMBLY|TRACEABILITY|MATERIAL[-_ ]?RECORD|(?:^|[^A-Z])MRB(?:[^A-Z]|$)/.test((ad ?? "").toUpperCase());
}
/** Adın sonundaki riser numarası; ad SN gövdesiyle bitiyorsa 0 ("sonda numara yok"), tanınmayan sonda null. */
function sondaki(t) {
    const p = SON_PARANTEZLI.exec(t);
    if (p)
        return p[1] === p[2] && Number(p[2]) > 0 ? { n: Number(p[2]), parantezli: true } : null;
    const d = SON_DUZ.exec(t);
    if (d)
        return Number(d[1]) > 0 ? { n: Number(d[1]), parantezli: false } : null;
    const y = SON_YOK.exec(t);
    if (!y)
        return null;
    const on = t.slice(0, y.index);
    return ONDE_SAYI.test(on) && !ONDE_EK.test(on) ? null : 0;
}
/** Etiketin ardındaki metinde `n`den başka bir riser numarası olabilecek parça var mı (1. kural). */
function baskaNumaraVar(kalan, n) {
    return kalan.split(/[^A-Z0-9]+/).some((p) => {
        const m = /^(?:R|RN|RISER|NO)?(\d{1,3})$/.exec(p);
        return m !== null && Number(m[1]) !== n;
    });
}
function rnBul(ham) {
    const t = ham.replace(KOPYA_EKI, "");
    const k1 = /^R[-_ ]?(\d{1,3})(?!\d)/.exec(t);
    const etiketli = k1 && Number(k1[1]) > 0 ? Number(k1[1]) : null;
    const kalan = k1 ? t.slice(k1[0].length) : "";
    const i = t.indexOf("SURVREP");
    if (i < 0)
        return etiketli && !baskaNumaraVar(kalan, etiketli) ? rnYaz(etiketli) : null;
    const b = /^(\d{1,3})[-_ ]SURVREP(?![A-Z0-9])/.exec(t);
    const etiketliBas = etiketli && /^[-_ ]SURVREP(?![A-Z0-9])/.test(kalan) ? etiketli : null;
    const bas = etiketliBas ?? (b && Number(b[1]) > 0 ? Number(b[1]) : null);
    if (!bas && /\d/.test(t.slice(0, i)))
        return null;
    const son = sondaki(t);
    if (son) {
        if (bas)
            return bas === son.n ? rnYaz(bas) : null;
        return son.n === 1 && !son.parantezli ? null : rnYaz(son.n);
    }
    if (!bas)
        return null;
    return son === 0 || (etiketliBas && !baskaNumaraVar(kalan, bas)) ? rnYaz(bas) : null;
}
//# sourceMappingURL=rapor-dosya.js.map